import { render, staticRenderFns } from "./rechargeadmin.vue?vue&type=template&id=b1801876&scoped=true"
import script from "./rechargeadmin.vue?vue&type=script&lang=js"
export * from "./rechargeadmin.vue?vue&type=script&lang=js"
import style0 from "./rechargeadmin.vue?vue&type=style&index=0&id=b1801876&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1801876",
  null
  
)

export default component.exports